import { Box } from '@mui/material';

import Page from '../../components/Page/index.ts';
import StaticPageLayout from '../../components/StaticPageLayout/index.ts';

export default function PrivacyStatement() {
  return (
    <Page title="Personvernerklæring">
      <StaticPageLayout
        title="Personvernerklæring"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Personvernerklæring',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 11.06.2026"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h2>1 – Innledning</h2>
          <p>
            Denne personvernerklæringen gjelder Scoopr AS behandling av personopplysninger om
            besøkende på{' '}
            <a href="https://scoopr.no/" target="_blank" rel="noreferrer">
              https://scoopr.no/
            </a>{' '}
            («våre nettsider»), samarbeidspartnere, leverandører, privatkunder, bedriftskunder og
            andre som kontakter Scoopr (heretter «kunde», «du», «deg»).
          </p>
          <p>
            Merk våre generelle brukervilkår{' '}
            <a href="https://scoopr.no/brukervilkar-min-scoopr" target="_blank" rel="noreferrer">
              her
            </a>{' '}
            som gjelder for alle tjenester som tilbys av Scoopr.
          </p>
          <p>
            Ditt personvern er viktig for Scoopr. For å sikre ditt personvern baserer vi oss på
            prinsippet om at kunden eier alle sine personopplysninger. Dette gjelder både
            informasjonen du deler med oss, men også informasjon vi innhenter på dine vegne. Dette
            krever at du vet hvilke personopplysninger vi innhenter og behandler. Denne
            personvernerklæringen gir deg informasjon om hvilke personopplysninger Scoopr samler
            inn, hvorfor Scoopr behandler personopplysningene og dine rettigheter i forbindelse med
            behandlingen av personopplysningene. Scoopr vil alltid behandle dine personopplysninger
            i tråd med den til enhver tid gjeldende personvernlovgivningen.
          </p>

          <h2>2 – Behandlingsansvarlig for dine personopplysninger</h2>
          <p>
            Oppretter du en Scoopr-konto hos Scoopr, vil du kunne få tilgang til en rekke tjenester
            som finansiering og forsikring. Scoopr har også felles kundeservice, som du finner på{' '}
            <a href="https://scoopr.no/kundeservice" target="_blank" rel="noreferrer">
              scoopr.no/kundeservice
            </a>
            .
          </p>
          <p>
            Scoopr AS (org.nr. 952 660 225) er behandlingsansvarlig for all behandling av
            personopplysninger.
          </p>
          <p>
            Scoopr har opprettet en felles Data Privacy Officer (DPO). Dersom du har spørsmål
            knyttet til Scooprs behandling av dine personopplysninger eller denne
            personvernerklæringen, kan du kontakte oss ved henvendelse til: Scoopr, Karenslyst Allé
            2, 0278 Oslo. Du kan også sende en e-post til vår DPO på{' '}
            <a href="mailto:dpo@scoopr.no">dpo@scoopr.no</a>.
          </p>

          <h2>3 – Personopplysninger som behandles, formål og rettslig grunnlag</h2>
          <h3>3.1 Generelt</h3>
          <p>
            Scoopr behandler personopplysninger om kontaktpersoner hos kunder, leverandører og andre
            samarbeidspartnere, samt om besøkende på våre nettsider, brukere av våre tjenester og
            personer som kontakter Scoopr, f.eks. ved å melde seg på nyhetsbrev. Scoopr samler inn
            personopplysningene om deg på ulike måter, eksempelvis via våre nettsider, via telefon
            og mail eller andre kommunikasjonsmåter, og i forbindelse med samarbeid med kunder og
            leverandører hvor vi mottar personopplysningene dine fra deg eller din arbeids- eller
            oppdragsgiver.
          </p>
          <p>Scoopr behandler personopplysninger til følgende formål:</p>

          <h3>3.2 Generelle formål</h3>
          <ul className="list-disc pl-6">
            <li>
              <b>Administrasjon av Scoopr-konto:</b> Informasjon som er nødvendig for å opprette og
              registrere din Scoopr-konto. Vi innhenter navn, fødselsnummer, telefonnummer og
              e-postadresse. Behandlingen har grunnlag i avtalen kunden inngår når kunden oppretter
              en Scoopr-konto og er nødvendig for at vi skal kunne administrere kundeforholdet ditt
              i Scoopr, for identifisering og for å beskytte både deg og Scoopr mot misbruk.
            </li>
            <li>
              <b>Besvarelse av henvendelser:</b> For å motta og besvare henvendelser til Scoopr, for
              eksempel via våre nettsider eller ved bruk av andre tjenester. Dette kan innebære
              behandling av personopplysninger som navn, tittel/funksjon, telefonnummer,
              e-postadresse, postadresse og andre opplysninger du oppgir.
            </li>
            <li>
              <b>Levering og tilpasning av tjenester:</b> Informasjon som oppgis ved registrering av
              Scoopr-konto kan, ved kundens samtykke, benyttes for å gi tilbud om andre tjenester.
              Ved kundens samtykke kan Scoopr også innhente og lagre informasjon fra tredjeparter,
              som usikret gjeld, kredittscore og kredittopplysninger, inntekt, skatt, formue,
              eiendomsinformasjon m.m. for å levere monitoreringstjenester og gi konkurransedyktige
              tjenester og tilbud.
            </li>
            <li>
              <b>Administrasjon av kunde-, leverandør- og samarbeidsforhold:</b> Vi behandler navn,
              tittel/funksjon og kontaktinformasjon for å administrere kontraktsforhold.
            </li>
            <li>
              <b>Forbedre våre tjenester:</b> Vi behandler bruksdata for å forbedre nettsider og
              tjenester, basert på samtykke eller interesseavveining. Slike data innhentes bl.a. ved
              bruk av cookies.
            </li>
            <li>
              <b>Nyhetsbrev, markedsføring og telefonkontakt:</b> Ved ditt samtykke
              («Scoopr-fordel») kan Scoopr bruke navn, e-post, telefonnummer og bruksdata til å
              kontakte deg med relevant markedsføring og produktoppdateringer via e-post, SMS,
              telefon og push-varsler. Samtykket er frivillig og kan trekkes tilbake når som helst,
              jf. punkt 1.6 i brukervilkårene.
            </li>
            <li>
              <b>Rekruttering:</b> Vi behandler opplysninger du oppgir i forbindelse med
              jobbsøknader.
            </li>
            <li>
              <b>Overholdelse av lovpålagte krav:</b> Vi kan behandle personopplysninger for å
              oppfylle lovpålagte krav, for eksempel regnskapskrav eller rapportering til offentlige
              myndigheter.
            </li>
            <li>
              <b>Ivaretakelse av rettigheter:</b> For å fastsette, gjøre gjeldende eller forsvare
              rettskrav, eller for å ivareta tredjeparters rettigheter.
            </li>
          </ul>

          <h3>3.3 Spesifikt for låneformidling og konkurranser</h3>
          <ul className="list-disc pl-6">
            <li>
              <b>Innhente finansieringstilbud:</b> Når du ber Scoopr om å innhente lånetilbud, kan
              vi behandle personopplysninger som navn, telefonnummer, e-postadresse, adresse,
              fødsels- og personnummer, kredittopplysninger, familieforhold, gjelds- og
              inntektsopplysninger, bosted, utdannelse, arbeidsgiver, statsborgerskap, kontonummer
              og andre nødvendige opplysninger.
            </li>
            <li>
              <b>Avholde konkurranser:</b> Scoopr avholder fra tid til annen konkurranser med
              premier. Dette kan innebære behandling av navn, kontaktopplysninger, fødsels- og
              personnummer, samt kredittopplysninger. Opplysningene brukes for å administrere
              konkurransen og kommunisere med deltakerne.
            </li>
          </ul>

          <h2>4 – Oppbevaring av personopplysninger</h2>
          <p>
            Scoopr vil ikke lagre dine personopplysninger lenger enn det som er nødvendig for å
            oppnå formålene som beskrevet over. Dersom behandlingen beror på samtykke, vil
            behandlingen opphøre og opplysningene slettes når du trekker ditt samtykke tilbake.
          </p>
          <p>
            Dersom du ber oss om å slette din profil eller du sier opp ditt kundeforhold, vil Scoopr
            slette eller anonymisere dine personopplysninger når kundeforholdet opphører, med mindre
            vi må beholde enkelte opplysninger som følge av lovpålagte krav eller andre rettslige
            forpliktelser.
          </p>

          <h2>5 – Beskyttelse av personopplysninger</h2>
          <p>
            Scoopr har iverksatt sikkerhetstiltak for å beskytte dine personopplysninger mot brudd
            på personopplysningssikkerheten og uautorisert tilgang eller utlevering. Vi er svært
            bevisste på at all informasjon som er personlig eller kan knyttes til deg skal behandles
            på en forsvarlig måte.
          </p>

          <h2>6 – Utlevering av personopplysninger til tredjeparter</h2>
          <p>
            Scoopr kan dele dine personopplysninger med samarbeidspartnere innen forsikring og
            finansiering, basert på dine forespørsler. Med samtykke kan vi også dele opplysninger
            som navn og e-post med tredjeparter for skreddersydd kommunikasjon og markedsføring.
          </p>
          <p>
            Vi bruker også underleverandører (databehandlere) som leverer tjenester vi er avhengige
            av for å kunne levere våre tjenester til deg. Disse reguleres gjennom
            databehandleravtaler.
          </p>
          <p>
            Vi kan videre utlevere opplysninger dersom vi har rettslig grunnlag, for eksempel ved
            lovpålagt rapportering til offentlige myndigheter.
          </p>
          <p>
            Dine personopplysninger kan behandles eller lagres utenfor EU/EØS. I slike tilfeller
            sikrer Scoopr tilstrekkelige garantier gjennom EUs standardvilkår eller overføring til
            land godkjent av EU-kommisjonen.
          </p>

          <h2>7 – Andre nettsteder og sosiale medier</h2>
          <p>
            Våre nettsider kan inneholde lenker til andre nettsteder. Disse har egne
            personvernerklæringer som vi anbefaler at du setter deg inn i.
          </p>
          <p>
            Dersom du bruker Scooprs sider på sosiale medier, vil den aktuelle plattformen være
            ansvarlig for opplysninger de samler inn.
          </p>

          <h2>8 – Dine rettigheter</h2>
          <p>
            Du har rettigheter etter personvernregelverket, inkludert rett til innsyn, retting,
            sletting, dataportabilitet og å trekke samtykke tilbake. Du kan også protestere mot
            behandling og be om begrensning.
          </p>
          <p>
            Dersom du mener Scoopr ikke overholder regelverket, kan du klage til Datatilsynet. Vi
            setter likevel pris på om du kontakter oss først, slik at vi kan rette opp eventuelle
            feil.
          </p>

          <h2>9 – Endringer i personvernerklæringen</h2>
          <p>
            En oppdatert versjon av personvernerklæringen vil alltid være tilgjengelig på våre
            nettsider. Dersom endringer krever nytt samtykke, vil vi informere deg og be om dette.
          </p>

          <h3>Kontaktinformasjon</h3>
          <h4>Scoopr AS</h4>
          <h4>Scoopr Refinansiering AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
